import { Enum } from "./Enum";

export const E_AMENITY = Object.freeze({
  MAIN: "/project-amenity",
  AMENITY_ID: (id: string = ":id") => `/project-amenity/${id}`,
});

export type E_AMENITY = Enum<typeof E_AMENITY>;
